// extracted by mini-css-extract-plugin
export default {"wrap":"PromoCodesComponent_wrap__0g9SV","btnBlock":"PromoCodesComponent_btnBlock__83ho5","listBlock":"PromoCodesComponent_listBlock__1r4sU"};